var __initialized = false;

export default function googleMaps() {
  return new Promise(function (resolve, reject) {
    if (__initialized && window.google) {
      resolve(window.google);
      return;
    }
    var script = document.createElement('script');
    var envApiKey = "AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8";
    if (location.hostname !== "www.buyatoyota.com") {
      envApiKey = "AIzaSyDFiAZqwtWPEoQMCrtjkO1PiYZtRPqlJW0";
    }
    script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=' + envApiKey;
    script.async = true;
    script.onload = function () {
      __initialized = true;
      resolve(window.google);
    };
    script.onerror = function (err) {
      reject(err);
    };
    document.head.appendChild(script);
  });
};
